<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <b-container v-else>

        <router-link class="admin-link" to="/Admin/MmlCategories">&larr; Перейти к списку категорий MML</router-link>
        
        <div class="admin-title">{{header}}</div>
        <hr class="my-4">

        <label for="nameMmlCategory">Введите название категории MML*</label>
        <b-form-input id="nameMmlCategory" class="mb-13" v-model="entity.Name" />

        <label for="promptMmlCategory">Подсказка</label>
        <b-textarea id="promptMmlCategory" class="mb-13" v-model="entity.Prompt" />

        <b-row>

            <b-col>
                <label for="subTypeMmlCategory">Выберите тип*</label>
                <custom-multiselect id="subTypeMmlCategory" 
                                    v-model="entity.SubType"
                                    :options="subTypes"
                                    track-by="Text" />
            </b-col>

            <b-col>
                <label for="codeMmlCategory">Выберите код сегмента*</label>
                <custom-multiselect id="codeMmlCategory"
                                    v-model="entity.Code"
                                    :options="segmentCodes" />
            </b-col>    

        </b-row>

        <hr class="my-4">

        <b-row>
            <b-col cols="3">
                <label class="mt-7">Выберите изображение*</label>
            </b-col>
            <b-col>
                <open-file-dialog v-model="entity.Image" 
                                  accept="image/jpeg,image/png"
                                  :url-file-open="entity.ImageUrl" 
                                  :is-image="true"
                                  :is-size-check="false" />
            </b-col>
        </b-row>

        <hr class="my-4">

        <label for="mmlRangeForTea">Диапозон значений MML для чая</label>
        <custom-multiselect id="mmlRangeForTea"
                            class="mb-13" 
                            v-model="entity.MmlRangeForTea"
                            :options="optionsMmlRangeForTea"
                            :multiple="true"
                            :taggable="true"
                            placeholder="Введите или выберите диапозон значений MML для чая"
                            tag-placeholder="Нажмите enter для создания значения"
                            @tag="addTagMmlRangeForTea" />


        <label for="mmlRangeForCoffee">Диапозон значений MML для кофе</label>
        <custom-multiselect id="mmlRangeForCoffee" 
                            v-model="entity.MmlRangeForCoffee"
                            :options="optionsMmlRangeForCoffee"
                            :multiple="true"
                            :taggable="true"
                            placeholder="Введите или выберите диапозон значений MML для кофе"
                            tag-placeholder="Нажмите enter для создания значения"
                            @tag="addTagMmlRangeForCoffee" />

        <hr class="my-4">

        <b-row class="m-0">

            <b-col cols="2" class="p-0 mr-10">
			    <b-button block 
                          id="admin-btn-save"
                          class="admin-button"    
                          @click="saveMmlCategory">
                    Сохранить
                </b-button>
            </b-col>

            <b-col cols="2" class="p-0">
			    <b-button block v-if="id"
                          id="admin-btn-cancel"
                          class="admin-button" 
                          @click="deleteMmlCategoryDialog">
                    Удалить
                </b-button>
            </b-col>

		</b-row>

    </b-container>

</template>
<script>
import AllRoutes from '@/routes/all.routes'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import OpenFileDialog from '@/components/shared/OpenFileDialog'

import MmlCategoryEditModel from '@/store/models/admin/mmlCategories/MmlCategoryEdit'
import Consts from '@/store/models/consts/adminConsts'

export default {
    computed: {
        header: function() {
            return this.id == null
                ? "Создание новой категории MML"
                : "Редактирование категории MML";
        }
    },
    data: function() {
        let load = new Loading();

        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id
                    : null;
        let entity;

        if(id) 
            this.getMmlCategory(load, id)
        else 
            entity = new MmlCategoryEditModel();

        return {
            load: load,
            
            id: id,
            entity: entity,

            subTypes: Consts.TradePointTypes,
            segmentCodes: Consts.SegmentCodes,
            optionsMmlRangeForTea: [],
            optionsMmlRangeForCoffee: []
        }
    },
    methods: {
        getMmlCategory: function(load, id) {
            load.Calculate(true);

            apiService.Admin.MmlCategories.Get(id) 
                .then(response => {
                    this.entity = new MmlCategoryEditModel().mapFromDto(response.data);
                    this.optionsMmlRangeForTea = JSON.parse(JSON.stringify(this.entity.MmlRangeForTea));
                    this.optionsMmlRangeForCoffee = JSON.parse(JSON.stringify(this.entity.MmlRangeForCoffee));
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },
        addTagMmlRangeForTea: function(newTag) {
            const tag = {
					Id: `tag-tea-${newTag.substring(0, 2)}-${Math.floor((Math.random() * 1000))}`,
					Text: newTag
                };
                
				this.optionsMmlRangeForTea.push(tag);
				this.entity.MmlRangeForTea.push(tag);
        },
        addTagMmlRangeForCoffee: function(newTag) {
            const tag = {
					Id: `tag-coffee-${newTag.substring(0, 2)}`,
					Text: newTag
                };
                
				this.optionsMmlRangeForCoffee.push(tag);
				this.entity.MmlRangeForCoffee.push(tag);
        },
        saveMmlCategory: function() {
            if(!this.entity.isValid()) {
                dialogService.showAlert('Предупреждение', 'Вы не заполнили все обязательные поля');
                return;
            }

            this.load.Calculate(true);
            let mmlCategoryDto = this.entity.mapToDto();

            apiService.Admin.MmlCategories.PostUpdate(mmlCategoryDto)
                .then(response => this.$router.push(AllRoutes.Admin.MmlCategories.Index))
                .catch(error => this.load.Calculate(false));
        },
        deleteMmlCategoryDialog: function() {
            if(!this.id)
                return;

            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данную категорию MML?')
                .then(ok => {
                    this.deleteMmlCategory();
                })
                .catch(cancel => {});
        },
        deleteMmlCategory: function() {
            this.load.Calculate(true);

            apiService.Admin.MmlCategories.PostDelete(this.id)
                .then(response => this.$router.push(AllRoutes.Admin.MmlCategories.Index))
                .catch(error => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        CustomMultiselect,
        OpenFileDialog
    }
}
</script>